import React from "react";

const STATUS_TONE = {
  to_verify: "bg-red-50 text-red-800 border-red-200", ready: "bg-emerald-50 text-emerald-800 border-emerald-200",
  baseline_approved: "bg-sky-50 text-sky-800 border-sky-200", not_configured: "bg-suite-neutral-100 text-suite-neutral-700 border-suite-neutral-200",
};

export const StatusBadge = ({ status, label, testId }) => (
  <span className={`inline-block rounded border px-1.5 py-0.5 text-[11px] font-medium ${STATUS_TONE[status] || STATUS_TONE.not_configured}`} data-testid={testId}>{label}</span>
);
